// PAB FAQ — one-open-at-a-time accordion.
class PabFaq extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pab-faq-btn]');
      if (!btn) return;
      const item = btn.closest('.qa');
      const open = !item.classList.contains('open');
      this.querySelectorAll('.qa.open').forEach((i) => {
        i.classList.remove('open');
        i.querySelector('[data-pab-faq-btn]')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  }
}

if (!customElements.get('pab-faq')) customElements.define('pab-faq', PabFaq);
